export const BASE_PATH = "https://cursostackmern-server.herokuapp.com/api";
// export const BASE_PATH = "http://localhost:3977/api";
export const API_VERSION = "v1";